import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
	selector: 'tabs-panel',
	template: require('./tabs-panel.component.html'),
	styles: [require('./tabs-panel.component.scss')]
})
export class TabsPanel {
	@Input() disabled = false;
	@Output() onClickTab: EventEmitter<any> = new EventEmitter<any>();
	tabs = [];

	selectTab(tab) {
		this.tabs.forEach(tab => {
			tab.active = false;
		});
		tab.active = true;
		this.onClickTab.emit(tab);
	}

	addTab(tab) {
		this.tabs.push(tab);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./web/modern/components/common/tabs-panel/tabs-panel.component.ts